import { useQuery } from "@tanstack/react-query";
import { getCarriers } from "../../api/TICKET/transport";

export const useCarriers = () =>
  useQuery({
    queryKey: ["carriers"],
    queryFn: getCarriers,
    staleTime: 5 * 60 * 1000,
  });